<div class="card mt-3">
    <div class="card-header">
        <h5><fa-icon icon="list-alt"></fa-icon> {{title | translate}}</h5>
        <div *ngIf="nrOfActiveFilters > 0" class="filter-indicator"> Active filters: {{ nrOfActiveFilters }} </div>
    </div>
    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>